<div class="bgList">
    <div class="item" [ngClass]="{active : i == activeIndex }" *ngFor="let item of pageBgList; let i = index;" >
        <img  [src]="item.img"  alt="">
        <div class="searchWrapper">
            <div class="searchText" (click)="search(item.search)">{{item.search}}</div>
        </div>
    </div>
    <div class="buttonsWrapper">
        <div class="buttons">
            <!-- <div class="searchInspo">
                &nbsp;
            </div> -->
            <div class="prev" (click)="prev()">
                <mat-icon>west</mat-icon>
            </div>
            <div class="next" (click)="next()">
                <mat-icon>east</mat-icon>
            </div>
        </div>

    </div>
</div>
